import React from 'react';

export const IntentAllocationTableCell = ({ record, column }) => (
  <div className={column.className}>
    {column.render({ value: column.accessor(record), record })}
  </div>
);

export default IntentAllocationTableCell;
